/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/self-closing-comp */
/*
 * Delete (modal contents) Component
 *
 */
import {useState} from 'react';
import './Delete.scss';
import Util from '../util/Util';
import Locale from '../util/Locale';
import LoadingIndicator from './LoadingIndicator';

function renderStatusIcon(status) {
    if (status === true) {
        return (
            <svg
                className="fileStatus"
                fill="none"
                height="16"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <polyline points="20 6 9 17 4 12" />
            </svg>
        );
    }
    if (status === false) {
        return (
            <svg
                className="fileStatus"
                fill="none"
                height="16"
                stroke="#CC4331"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" />
                <line x1="12" x2="12" y1="8" y2="12" />
                <line x1="12" x2="12" y1="16" y2="16" />
            </svg>
        );
    }
    return null;
}

function getFancyType(asset) {
    if (asset && asset.mimeType && asset.label) {
        let part1 = Util.getFileTypeLabelFromMimeType(asset.mimeType, asset);
        let part2 = Util.getFileExtension(asset.label);
        if (part1 === Util.FILE_TYPE.PDF) {
            part2 = part1;
            part1 = Util.FILE_TYPE.DOCUMENT;
        } else if (part2 === '') {
            return Locale.getText(part1).toUpperCase();
        }
        return `${Locale.getText(part1)}/${part2}`.toUpperCase();
    }
    return '';
}

function renderFileEntry(asset, status) {
    const type = getFancyType(asset);
    const fileSize = asset.fileSize ? Util.byteSizeString(asset.fileSize) : '';
    return (
        <div className="fileEntry" key={asset.id}>
            {renderStatusIcon(status)}
            <div className="fileDetails">
                <div>{type}</div>
                <div className="fileLabel">{Util.decodeLabel(asset.label)}</div>
                <div>{fileSize}</div>
            </div>
            {Util.getThumbnail(asset)}
        </div>
    );
}

function renderInstructions(isDone, fileCount) {
    if (isDone) {
        return null;
    }
    return (
        <div className="instructions">
            <span>{Locale.getText('DELETE_INSTRUCTION')}</span>
            <span className="fileCount">
                {fileCount} {Locale.getText('N_FILES')}
            </span>
        </div>
    );
}

function renderFooter(props, isDone, setStatusList, statusList, setIsLoading, isLoading) {
    if (isDone) {
        return (
            <div className="footerActions">
                <div></div>
                <nsemble-button
                    key="CLOSE"
                    text
                    onClick={() => {
                        props.setShowModal(false);
                        if (props.setShowFocused && statusList.includes(true)) {
                            props.setShowFocused(false); // Remove Details page if on it
                        }
                    }}
                >
                    {Locale.getText('CLOSE')}
                </nsemble-button>
            </div>
        );
    }
    return (
        <div className="footerActions">
            <nsemble-button
                key="CANCEL"
                text
                onClick={() => {
                    props.setShowModal(false);
                }}
            >
                {Locale.getText('CANCEL')}
            </nsemble-button>
            <LoadingIndicator isLoading={isLoading}>
                <nsemble-button
                    key="DELETE"
                    destructive-text
                    onClick={async event => {
                        const button = event.currentTarget;
                        setIsLoading(true);
                        button.disabled = true;
                        const results = await props.onAction(props.list);
                        button.disabled = false;
                        setStatusList(results);
                        setIsLoading(false);
                    }}
                >
                    {Locale.getText('DELETE')}
                </nsemble-button>
            </LoadingIndicator>
        </div>
    );
}

function renderResults(results) {
    if (!results) {
        return null;
    }

    const goodResults = results.filter(status => status).length;
    const badResults = results.length - goodResults;
    return (
        <div className="results">
            {/* eslint-disable-next-line no-extra-boolean-cast */}
            {Boolean(goodResults) && !Boolean(badResults) && (
                <div className="goodResults">{Locale.getText('ALL_FILES_DELETED')}</div>
            )}
            {/* eslint-disable-next-line no-extra-boolean-cast */}
            {Boolean(goodResults) && Boolean(badResults) && (
                <div className="goodResults">
                    {goodResults} {Locale.getText('SOME_FILES_DELETED')}
                </div>
            )}
            {/* eslint-disable-next-line no-extra-boolean-cast */}
            {Boolean(goodResults) && Boolean(badResults) && (
                <div className="badResults">
                    {badResults} {Locale.getText('SOME_FILES_NOT_DELETED')}
                </div>
            )}
            {/* eslint-disable-next-line no-extra-boolean-cast */}
            {!Boolean(goodResults) && Boolean(badResults) && (
                <div className="badResults">{Locale.getText('ALL_FILES_NOT_DELETED')}</div>
            )}
        </div>
    );
}

function renderContents(props, statusList, setStatusList, setIsLoading, isLoading) {
    const isDone = statusList !== null;
    const results = statusList || [];
    return (
        <div>
            <div id="modal-header">
                <h1>{props.title}</h1>
            </div>
            <div id="modal-body">
                <div className="modalContents">
                    {props.list.length > 1 && renderInstructions(isDone, props.list.length)}
                    <div className="fileList">
                        {props.list.map((asset, index) => renderFileEntry(asset, results[index]))}
                    </div>
                    {renderResults(results)}
                </div>
            </div>
            <div id="modal-footer">{renderFooter(props, isDone, setStatusList, results, setIsLoading, isLoading)}</div>
        </div>
    );
}

export default function Delete(props) {
    const [statusList, setStatusList] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    return props && props.list ? renderContents(props, statusList, setStatusList, setIsLoading, isLoading) : null;
}
